import { render, staticRenderFns } from "./JpReceDLEditDialog.vue?vue&type=template&id=21e3f894&scoped=true"
import script from "./JpReceDLEditDialog.vue?vue&type=script&lang=js"
export * from "./JpReceDLEditDialog.vue?vue&type=script&lang=js"
import style0 from "./JpReceDLEditDialog.vue?vue&type=style&index=0&id=21e3f894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3f894",
  null
  
)

export default component.exports